export default __webpack_public_path__ + "static/media/bar-offers-2.909d90b7.png";